import { render, staticRenderFns } from "./WhatsappImage.vue?vue&type=template&id=8d0b63f6&"
import script from "./WhatsappImage.vue?vue&type=script&lang=js&"
export * from "./WhatsappImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports